import React, { useState } from "react";
import "../../styles/Faq/faq.css"; // Ensure this path matches your file structure

const FAQSection = () => {
  // State to track which question is currently open (null = all closed)
  const [activeId, setActiveId] = useState(null);

  // Toggle function
  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  // Updated Data based on your image
  const faqData = [
    {
      id: 1,
      question: "Do I need work experience to enroll?",
      answer:
        "Depends on the course. US CMA requires 2 years of relevant experience, CPA requires specific education credits, and EA has no minimum work experience requirement.",
    },
    {
      id: 2,
      question: "Can I work abroad after completing these courses?",
      answer: "Yes, provided you meet visa and local licensing requirements.",
    },
  ];

  return (
    <section className="faq-section  py-5">
      <div className="container ml-5 mr-5">
        {/* Title Section with Purple Bar */}
        <div
          className="d-flex align-items-center mb-5"
          style={{ marginLeft: "0" }}
        >
          {/* Removed huge left margin to align standardly, or keep '8%' if desired */}
          <div className="title-bar me-3"></div>
          <h2 className="fw-bold text-dark m-0">Frequently Asked Questions</h2>
        </div>

        {/* FAQ List */}
        <div className="row">
          <div className="col-12">
            {faqData.map((item) => (
              <div
                key={item.id}
                className={`faq-item mb-3 ${
                  activeId === item.id ? "active" : ""
                }`}
                onClick={() => toggleFAQ(item.id)}
              >
                {/* Question Header */}
                <div className="faq-header d-flex justify-content-between align-items-center p-3 cursor-pointer">
                  <h6
                    className={`m-0 fw-semibold ${
                      activeId === item.id ? "text-purple" : "text-dark"
                    }`}
                  >
                    {item.question}
                  </h6>
                  {/* Icon switches between Up and Down chevron */}
                  <i
                    className={`bi bi-chevron-${
                      activeId === item.id ? "up" : "down"
                    } transition-icon ${
                      activeId === item.id ? "text-purple" : ""
                    }`}
                  ></i>
                </div>

                {/* Answer Body (Collapsible) */}
                <div
                  className={`faq-body ${activeId === item.id ? "show" : ""}`}
                >
                  <div className="p-3 pt-0 text-muted small lh-lg">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
